import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface SignInIconStyles {
    signInIcon?: InjectableCss;
}

export const signInIconStyles: SignInIconStyles = {
    signInIcon: {
        css: css`
            display: flex;
            & path {
                fill: none;
                stroke: #000;
                stroke-width: 1.5px;
            }
        `,
    },
};

const styles = signInIconStyles;

const SignInIcon: React.FC = () => {
    return (
        <StyledWrapper {...styles.signInIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18.196" height="18.196" viewBox="0 0 18.196 18.196">
                <g transform="translate(-1312.75 -69.75)">
                    <path
                        className="signInIcon"
                        d="M8.348,9.391a4.7,4.7,0,1,0-4.7-4.7A4.7,4.7,0,0,0,8.348,9.391Zm4.174,1.043h-1.8a5.676,5.676,0,0,1-4.754,0h-1.8A4.174,4.174,0,0,0,0,14.609v.522A1.566,1.566,0,0,0,1.565,16.7H15.13A1.566,1.566,0,0,0,16.7,15.13v-.522A4.174,4.174,0,0,0,12.522,10.435Z"
                        transform="translate(1313.5 70.5)"
                    />
                </g>
            </svg>
        </StyledWrapper>
    );
};

export default React.memo(SignInIcon);
